import {
    Link
}

from "react-router-dom";
import {
    BarChart3, TrendingUp, Gauge, ArrowLeft
}

from "lucide-react";

export default function PerformanceAnalytics() {
    return (
    <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
    <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
      <div className="flex items-center gap-3 mb-6">
        <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
        <h1 className="text-2xl font-bold text-indigo-700">Performance Analytics</h1>
      </div>

      <p className="text-gray-600 mb-8">
        Understand outcomes with item statistics, candidate insights, and program-level reporting.
      </p>

      <section className="grid md:grid-cols-3 gap-6">
        <div className="rounded-xl border border-indigo-100 p-6">
          <div className="flex items-center gap-2 mb-3 text-indigo-700">
            <BarChart3 className="w-5 h-5" />
            <h3 className="font-semibold">Item Analysis</h3>
          </div>
          <p className="text-gray-700 text-sm">Difficulty, discrimination, distractor analysis.</p>
        </div>

        <div className="rounded-xl border border-indigo-100 p-6">
          <div className="flex items-center gap-2 mb-3 text-indigo-700">
            <TrendingUp className="w-5 h-5" />
            <h3 className="font-semibold">Cohort Trends</h3>
          </div>
          <p className="text-gray-700 text-sm">Compare sessions, locations, and accommodations.</p>
        </div>

        <div className="rounded-xl border border-indigo-100 p-6">
          <div className="flex items-center gap-2 mb-3 text-indigo-700">
            <Gauge className="w-5 h-5" />
            <h3 className="font-semibold">Program KPIs</h3>
          </div>
          <p className="text-gray-700 text-sm">Pass rates, completion, anomalies, and integrity signals.</p>
        </div>
      </section>

      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/support/contact" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">See a Sample Report</Link>
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 hover:text-indigo-800 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
      </div>
    </div>
  </main>
  );
}
